import {useTranslation} from 'react-i18next';

import {Grid, SxProps, Typography} from '@mui/material';

import EmpionLogo from '../../../../../../components/EmpionLogoAnimation/EmpionLogo';
import {EmpionPaper} from '../../../../../../components/EmpionPaper/EmpionPaper';
import {orangeColors} from '../../../../../../layouts/theme/designSystem';
import {
  CULTURAL_ANALYSIS_STATUS_COMPLETED,
  CULTURAL_ANALYSIS_STATUS_INEXISTENT,
  CULTURAL_ANALYSIS_STATUS_PENDING,
  CULTURAL_ANALYSIS_STATUS_STARTED,
} from '../../../../../../lib/constants';

interface Props {
  variant: string;
  subtitle: string;
}

const useTranslations = () => {
  const {t} = useTranslation('translation', {
    keyPrefix: 'companyCultureDashboard.status',
  });

  return {t};
};

const paperStyles: SxProps = {
  p: 8,
  backgroundColor: 'background.paper',
  borderRadius: 4,
};

const StatusComponent = ({variant, subtitle}: Props) => {
  const {t} = useTranslations();

  return (
    <Grid container justifyContent={'center'} textAlign={'center'} p={10}>
      <EmpionPaper sx={paperStyles}>
        <EmpionLogo withAnimation />
        <Typography variant='h1'>{t(variant)}</Typography>
        <Typography variant='h2' fontWeight={'400'} color={orangeColors[100]}>
          {t(subtitle)}
        </Typography>
      </EmpionPaper>
    </Grid>
  );
};

export const InexistentStatus = () => (
  <StatusComponent variant={CULTURAL_ANALYSIS_STATUS_INEXISTENT} subtitle='inexistentSubtitle' />
);
export const PendingStatus = () => (
  <StatusComponent variant={CULTURAL_ANALYSIS_STATUS_PENDING} subtitle='pendingSubtitle' />
);
export const StartedStatus = () => (
  <StatusComponent variant={CULTURAL_ANALYSIS_STATUS_STARTED} subtitle='startedSubtitle' />
);
export const CompletedStatus = () => (
  <StatusComponent variant={CULTURAL_ANALYSIS_STATUS_COMPLETED} subtitle='completedSubtitle' />
);
